export enum VoiceFlagsActionKeyType {
  UNFLAG = "unFlag",
  ARCHIVE = "archive",
}